import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";
import {footerRechercheActivePicto} from "../../Theme/picto";

export interface FooterRechercheActivePictoProps extends pictoProps {
}

export interface FooterRechercheActivePictoState extends pictoState {
}

export class  FooterRechercheActivePicto extends Picto<FooterRechercheActivePictoProps,FooterRechercheActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerRechercheActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterRechercheActivePicto);
